import { Box, Container } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import HeroCst from "@components/HeroCst";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import PathsFormCst from "../PathsFormCst";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useEditPaths } from "@hooks/hookscatalog/Paths/useEditPaths";
import { useMemo, useState } from "react";

const EditPaths: React.FC<{
  duplication?: boolean;
}> = ({ duplication = false }) => {
  const { t } = useTranslation(["paths-page"]);
  const { id, idLO } = useParams();
  const navigate = useNavigate();
  const [confirmCompletedLOModal, setConfirmCompletedLOModal] =
    useState<any>(undefined);

  const {
    onSubmit,
    openToast,
    setOpenToast,
    columns,
    dataDetail,
    actionsForForms,
  } = useEditPaths(PagesID["corporate.catalog.path"], id, idLO, duplication);

  const formatData = useMemo(() => {
    const formatArr = { ...dataDetail };
    if (formatArr && Object.keys(formatArr).length > 0) {
      if (!!duplication) {
        return {
          ...dataDetail,
          publish_date: null,
          title: `${dataDetail.title} - Copied`,
          completable: false,
        };
      } else {
        return { ...dataDetail };
      }
    } else {
      return {};
    }
  }, [dataDetail]);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-paths.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t(`edit.hero-title${duplication ? "-duplicate" : ""}`)}
          description={t("edit.hero-description")}
        />
        {!!dataDetail && Object.keys(dataDetail).length > 0 && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <PathsFormCst
              row={formatData}
              columns={columns}
              onSubmit={onSubmit}
              setConfirmCompletedLOModal={setConfirmCompletedLOModal}
              backButton={() => {
                navigate(`/corporate/${id}/detail/catalog/paths`);
              }}
              actionsForForms={actionsForForms}
              idEntity={idLO}
              duplication={duplication}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
      <ModalConfirmsCst
        open={!!confirmCompletedLOModal}
        title={t("modal-confirm-completed.hero-title")}
        description={t("modal-confirm-completed.hero-description")}
        onCallBackClosed={() => {
          setConfirmCompletedLOModal(undefined);
        }}
        onActionConfirmed={() =>
          onSubmit(
            confirmCompletedLOModal.inputForm,
            confirmCompletedLOModal.fileUploaded,
          )
        }
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditPaths;
